import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HomePage } from "../../home/home";
import { ConfigurationServices } from '../../configuration/services';
import { TakeawayServices } from '../services';
import { TakeawayOrdersPage } from '../takeaway-orders/takeaway-orders';

/**
 * Generated class for the TpvLoaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-loader',
  templateUrl: 'takeaway-loader.html',
})
export class TakeawayLoaderPage {

  first_enter: boolean = true;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    public takeawayServices: TakeawayServices) {

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //limpiar tags al entrar en el loader
    this.takeawayServices.dish_tags = Array();
    this.takeawayServices.products_tags = Array();
    //Rooms
    this.takeawayServices.getRooms(this.globals.restaurant_uid);
    this.takeawayServices.getTablesTakeaway(this.globals.restaurant_uid);
    this.takeawayServices.getMenus(this.globals.restaurant_uid);
    this.takeawayServices.getCombos(this.globals.restaurant_uid);
    this.takeawayServices.getDish(this.globals.restaurant_uid);
    this.takeawayServices.getProducts(this.globals.restaurant_uid);
    this.takeawayServices.getCashs(this.globals.restaurant_uid);
    this.configurationServices.getRestaurant(this.globals.restaurant_uid);
    loadingPopup.dismiss();
    this.navCtrl.push(TakeawayOrdersPage);

  }

  ionViewDidLoad() {

  }

  ionViewCanEnter() {
    if (this.first_enter) {
      this.first_enter = false;
    } else {
      this.globals.side_menu_active = 'dashboard';
      this.navCtrl.setRoot(HomePage);
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-loader/takeaway-loader.ts